import { api } from '../lib/api-client.js';

export interface InboxNotification {
  id: string;
  category: string;
  urgency: 'urgent' | 'normal' | 'low';
  eventName: string;
  title: string;
  body: string;
  actionUrl: string | null;
  entityKind: string | null;
  entityId: string | null;
  readAt: string | null;
  dismissedAt: string | null;
  channelsAttempted: string[];
  channelsDelivered: string[];
  metadata: Record<string, unknown>;
  createdAt: string;
}

export interface InboxPage {
  notifications: InboxNotification[];
  nextCursor: string | null;
}

export async function fetchInbox(opts: {
  cursor?: string;
  limit?: number;
  unread?: boolean;
  category?: string;
}): Promise<InboxPage> {
  const params = new URLSearchParams();
  if (opts.cursor) params.set('cursor', opts.cursor);
  if (opts.limit) params.set('limit', String(opts.limit));
  if (opts.unread) params.set('unread', 'true');
  if (opts.category) params.set('category', opts.category);
  const q = params.toString();
  return api<InboxPage>(`/notifications${q ? `?${q}` : ''}`);
}

export async function fetchUnreadCount(): Promise<{ count: number }> {
  return api<{ count: number }>('/notifications/unread-count');
}

export async function markRead(id: string): Promise<{ notification: InboxNotification }> {
  return api<{ notification: InboxNotification }>(`/notifications/${id}/read`, {
    method: 'POST',
  });
}

export async function markAllRead(): Promise<void> {
  await api('/notifications/read-all', { method: 'POST' });
}

export async function dismiss(id: string): Promise<void> {
  await api(`/notifications/${id}/dismiss`, { method: 'POST' });
}
